import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';
import { useProfile } from '../contexts/ProfileContext';

const Layout = ({ children, onLogout }) => {
  const { profile } = useProfile();

  return (
    <div className="h-screen  flex overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Header userId={profile.userId} userGroup={profile.userGroup} onLogout={onLogout} />
        <main className="flex-1 overflow-y-auto p-8 bg-[#fefaf4]">
          {children}
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default Layout;